import { Flex, chakra, useCheckbox, Image } from '@chakra-ui/react';

const CheckBox = (props: any) => {
  const { state, getCheckboxProps, getInputProps, htmlProps } =
    useCheckbox(props);

  return (
    <chakra.label
      display="flex"
      justifyContent={'center'}
      alignItems="center"
      gridColumnGap={2}
      maxW={props.size + 'px'}
      cursor="pointer"
      {...htmlProps}>
      <input {...getInputProps()} hidden />
      <Flex
        alignItems="center"
        justifyContent="center"
        w={props.size + 'px'}
        h={props.size + 'px'}
        {...getCheckboxProps()}>
        {props.isDisabled ? (
          <Image
            src="/assets/images/icn_check-box_disable.svg"
            boxSize={props.size + 'px'}
          />
        ) : state.isChecked ? (
          <Image
            src="/assets/images/icn_check-box_y.svg"
            boxSize={props.size + 'px'}
          />
        ) : (
          <Image
            src="/assets/images/icn_check-box_n.svg"
            boxSize={props.size + 'px'}
          />
        )}
      </Flex>
    </chakra.label>
  );
};
export default CheckBox;
